<template>
  <div class="flex items-center gap-2 text-xl">
    <TextMultiline
      :text="i18n.t('accountingImports')"
      class="cursor-pointer"
      @click="goToAccounting" />
    <p>/</p>
    <SmSkeleton v-if="loading" width="100px" />
    <div v-else-if="accountingImport" class="flex items-center gap-2 font-bold">
      <TextMultiline :text="internalName" />
    </div>
    <p v-else>
      {{ i18n.t('accountingImports') }}
    </p>
  </div>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n'
  import { useRoute, useRouter } from 'vue-router'

  import { AccountingService, AccountingImportOut } from '@/client'
  import TextMultiline from '@/components/sm/TextMultiline.vue'
  import SmSkeleton from '@/components/sm/SmSkeleton.vue'

  const i18n = useI18n()
  const route = useRoute()
  const router = useRouter()

  const accountingImport = ref<AccountingImportOut>()
  const loading = ref(true)

  const internalName = computed(() => {
    if (!accountingImport.value) return
    return accountingImport.value.name || accountingImport.value.filename
  })

  onMounted(() => {
    loadImport()
  })

  const goToAccounting = () => {
    router.push({ name: 'Discovery', query: { tab: 'imports' } })
  }

  function loadImport() {
    const importId = route.params.id as string
    AccountingService.getAccountingImportApiV1AccountingAccountingImportsAccountingImportIdGet(
      {
        accountingImportId: importId,
      }
    )
      .then((record) => {
        accountingImport.value = record ?? undefined
      })
      .catch((error) => {
        console.error('Error loading accounting import:', error)
      })
      .finally(() => {
        loading.value = false
      })
  }
</script>
